"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    _reactContentLoader = _interopRequireDefault(require("react-content-loader")),
    colorMap = {
  darkTheme: {
    primaryColor: _vars.COLOURS.grey.nevada,
    secondaryColor: _vars.COLOURS.grey.raspingSandy
  },
  lightTheme: {
    primaryColor: _vars.COLOURS.grey.athens.bigFat,
    secondaryColor: _vars.COLOURS.grey.mischka.russian
  }
};

function getTheme(customTheme, _ref) {
  var darkTheme = _ref.darkTheme;
  return customTheme ? {
    primaryColor: _vars.FLATTENED_COLOURS[customTheme.primaryColor],
    secondaryColor: _vars.FLATTENED_COLOURS[customTheme.secondaryColor]
  } : darkTheme ? colorMap.darkTheme : colorMap.lightTheme;
}

function ContentLoaderWrapper(_ref2) {
  var _ref2$height = _ref2.height,
      height = void 0 === _ref2$height ? 140 : _ref2$height,
      width = _ref2.width,
      _ref2$speed = _ref2.speed,
      speed = void 0 === _ref2$speed ? 1.5 : _ref2$speed,
      darkTheme = _ref2.darkTheme,
      children = _ref2.children,
      customTheme = _ref2.customTheme,
      _getTheme = getTheme(customTheme, {
    darkTheme: darkTheme
  }),
      primaryColor = _getTheme.primaryColor,
      secondaryColor = _getTheme.secondaryColor;

  return _react["default"].createElement(_reactContentLoader["default"], {
    height: height,
    width: width,
    speed: speed,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  }, children);
}

var _default = (0, _react.memo)(ContentLoaderWrapper);

exports["default"] = _default;